import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container terms my-5">
      <h1 className="mb-4 text-black text-center">Privacy Policy</h1>

      {/* Intro section */}
      <p>
        Welcome to <strong>Hunarmand Punjab</strong>. We are committed to
        protecting your privacy and ensuring the security of your personal
        information. This Privacy Policy explains how we collect, use, store,
        protect, and manage your personal data when you access our official
        websites, register for training programs, scholarships, examinations,
        events, or use any of our online services.
      </p>
      <p>
        By accessing or using the official Hunarmand Punjab websites or
        services, you acknowledge that you have read, understood, and agreed to
        the practices described in this Privacy Policy.
      </p>
      <p>
        This Privacy Policy applies to all official websites operated by
        Hunarmand Punjab, including:
      </p>
      <ul>
        <li>
          <a
            href="https://hunarmandpunjab.pk"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://hunarmandpunjab.pk
          </a>
        </li>
        <li>
          <a
            href="https://hunarmandpunjab.org.pk"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://hunarmandpunjab.org.pk
          </a>
        </li>
      </ul>
      <p>
        By accessing or using either of these websites, you agree to the terms
        outlined in this Privacy Policy. Unless otherwise stated, all references
        to "Website," "we," "our," or "Hunarmand Punjab" apply collectively to
        both official domains.
      </p>

      <h5 className="mt-4 text-black">Official System-Generated Emails</h5>
      <p>
        Please note that all system-generated emails and official automated
        notifications from Hunarmand Punjab are sent exclusively through the{" "}
        <strong>hunarmandpunjab.com</strong> email domain. Users are advised to
        consider emails received from this domain as official communications of
        Hunarmand Punjab.
      </p>

      {/* Section 1 */}
      <h4 className="mt-4 text-black">1. Information Collection</h4>
      <p>
        To ensure a smooth and personalized experience, we collect the following
        details at the time of registration:
      </p>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Contact number</li>
        <li>CNIC</li>
        <li>Educational background</li>
      </ul>

      {/* Section 2 */}
      <h4 className="mt-4 text-black">2. Usage of Information</h4>
      <p>Your information helps us to:</p>
      <ul>
        <li>Facilitate your training in 25+ in-demand IT courses.</li>
        <li>Track your learning progress and performance.</li>
        <li>Keep you informed with course schedules, updates, and study material.</li>
        <li>Offer access to certified learning resources.</li>
        <li>Connect you with internship and job placement opportunities.</li>
      </ul>

      {/* Section 3 */}
      <h4 className="mt-4 text-black">3. Data Protection</h4>
      <p>Hunarmand Punjab follows strict data protection protocols:</p>
      <ul>
        <li>
          Your personal information is stored securely using industry-standard
          security measures.
        </li>
        <li>Only authorized personnel have access to your data.</li>
        <li>
          We strictly prevent any unauthorized use, sharing, or misuse of your
          information.
        </li>
      </ul>

      {/* Section 4 */}
      <h4 className="mt-4 text-black">4. Your Rights</h4>
      <p>You have the full right to:</p>
      <ul>
        <li>Request access to your personal data.</li>
        <li>Update or correct your details.</li>
        <li>Request deletion of your data from our records.</li>
      </ul>
      <p>
        For any such requests, feel free to contact us at{" "}
        <a href="mailto:support@hunarmandpunjab.org.pk">
          support@hunarmandpunjab.org.pk
        </a>.
      </p>

      {/* Section 5 */}
      <h4 className="mt-4 text-black">5. Tuition Fee & Processing Fee</h4>
      <p>
        All training programs offered under Hunarmand Punjab are advertised as
        tuition-free, meaning no monthly or semester tuition fees are charged to
        enrolled participants. A one-time processing fee of PKR 3,250 is payable
        at the time of enrollment to cover administrative processing, student
        onboarding, Learning Management System (LMS) access, digital resources,
        verification, and related service costs. The processing fee is eligible for reimbursement only to participants
        who complete the program and achieve a minimum of 85% marks in the Final
        Evaluation Test, subject to compliance with all applicable program
        policies and requirements.
      </p>
      {/* <p>
        The processing fee is eligible for reimbursement only to participants
        who complete the program and achieve a minimum of 85% marks in the Final
        Evaluation Test, subject to compliance with all applicable program
        policies and requirements.
      </p> */}

      {/* Section 6 */}
      <h4 className="mt-4 text-black">6. Final Examination & Scholarship Policy</h4>
      <p>
        The format, schedule, venue, and method of the Final Evaluation Test
        shall be determined solely by the Hunarmand Punjab management. The
        evaluation may be conducted online or physically, depending on academic,
        operational, quality assurance, and integrity requirements. To maintain
        fairness, transparency, and academic standards, Hunarmand Punjab
        reserves the right to require physical examinations where deemed
        appropriate. Eligibility for the Scholarship Card is strictly
        merit-based. Students who score below 85% in the final examination will
        not be eligible for the Scholarship Card. Final examination results are
        assessed solely on merit under the observation and evaluation of
        industrial trainers. The evaluation process is final, and no requests
        for rechecking, re-evaluation, score revision, or any related claims
        will be accepted.
      </p>

      <hr className="my-5" />

      {/* Affiliation / Bottom disclaimer */}
      <p className="text-muted" style={{ fontSize: "14px" }}>
        Hunarmand Punjab is focused on youth empowerment through its IT-Training Program.
        By enrolling in our programs, you acknowledge and agree to the terms
        outlined in this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
